import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import {
  selectCollection,
  SelectCollectionCallback,
} from 'actions/menu-collections/selectCollection'

export const useSelectCollection = () => {
  const dispatch = useDispatch()

  return useCallback(
    (id: string, callback: SelectCollectionCallback = () => {}) => {
      dispatch(selectCollection(id, callback))
    },
    [dispatch],
  )
}
